import React, { useEffect,useState } from 'react'
import { TextField, Grid, Box, Button } from "@mui/material"
import { useForm, Controller } from "react-hook-form"
import { yupResolver } from "@hookform/resolvers/yup"
import { FreeRideOneSchema } from '../../Utils/Validations'
import AuthState from '../../Hooks/Authinctication.state'
const RideFormOne = ({ handleBack, handleComplete, freeRideData, setFreeRideData }) => {
  const {CheckUser,formBusy,message} = AuthState()
  const [email,setEmail] = useState("")
  const [first_name,setFirst_name] = useState("")
  const [last_name,setLast_name] = useState("")
  const [name,setName] = useState("")
  const [error,setError] = useState("")
  const { handleSubmit, control, formState: { errors }, setValue } = useForm({
    resolver: yupResolver(FreeRideOneSchema)
  })
  useEffect(() => {
    setValue("first_name", freeRideData.first_name || "")
    setValue("last_name", freeRideData.last_name || "")
  setValue("company", freeRideData.company || "")
    setValue("email", freeRideData.email || "")
  }, [])
  const onSubmit = async (data) => {
    console.log(data)
    await CheckUser({email:data.email})
   
  }

  useEffect(()=>{
    if(message?.type==="error"){
      setError(message.message)
    }else if(errors?.email){
      setError(errors.email.message)
    }else{
      setError("")
    }
    if(message?.type==="success"){
      setFreeRideData((prev) => ({ ...prev, first_name: first_name,last_name:last_name, company: prev.company, email: email }))
      handleComplete()
    }
  },[message,errors])


  return (
    <div>

      <Grid container style={{ justifyContent: "center", marginTop: 20 }} >
        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 } }}>
          <Controller
            control={control}
            name="first_name"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <label>First Name</label>
                <TextField fullWidth value={value} placeholder='First Name' onChange={(e) => { onChange(e); setFirst_name(e.target.value) }} error={errors.first_name} helperText={errors?.first_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", px: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="last_name"
            rules={{ required: true }}
            render={({ field: { onChange, value } }) => (
              <>
                <label>Last Name</label>
                <TextField fullWidth value={value} placeholder='Last Name' onChange={(e) => { onChange(e); setLast_name(e.target.value) }} error={errors.last_name} helperText={errors?.last_name?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={4} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: { sm: 0, xs: 2 } }}>
          <Controller
            control={control}
            name="company"
            render={({ field:{onChange,value} }) => (
              <>
                <label>Company</label>
                <TextField fullWidth value={value} onChange={(e)=>{onChange(e); setFreeRideData((prev)=>({...prev, company: e.target.value}))}} placeholder='Company'  error={errors?.company} helperText={errors?.company?.message} />
              </>
            )}
          />
        </Grid>

        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingRight: { sm: 1, xs: 0 }, mt: 3 }}>
          <Controller
            control={control}
            name="email"
            rules={{ required: true }}
            render={({ field:{onChange,value} }) => (
              <>
                <label>Email Address</label>
                <TextField fullWidth value={value} onChange={(e)=>{onChange(e);setEmail(e.target.value)}} placeholder='Email Address'  error={error} helperText={error} />

              </>
            )}
          />

        </Grid>
        <Grid sm={6} xs={12} sx={{ textAlign: "left", paddingLeft: { sm: 1, xs: 0 }, mt: 3 }}>
          <label>Started from</label>
          <TextField
            fullWidth
            type="date"
            value={freeRideData.started_from || new Date().toISOString().split('T')[0]}
            onChange={(e) => setFreeRideData((prev) => ({ ...prev, started_from: e.target.value }))}
            sx={{
              "& input[type=date]::-webkit-calendar-picker-indicator": {
                filter: "invert(1)",
                opacity: 1,
                cursor: "pointer",
              },
            }}
          />
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', flexDirection: 'row', pt: 2,pb:2 }}>
        <Button
          color="inherit"
          // disabled={activeStep === 0}
          onClick={handleBack}
          sx={{ minWidth:"10%",border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }}
          variant="contained"
        >
          Back
        </Button>
        <Box sx={{ flex: '1 1 auto' }} />


        <Button color="inherit" variant="contained" sx={{ minWidth:"10%",border: "none", color: "#FFF", bgcolor: "#97c11e", '&:hover': { bgcolor: "#021b38", border: "none" } }} onClick={handleSubmit(onSubmit)}>


          {formBusy?"Please wait...": "Next"}
        </Button>

      </Box>
    </div>
  )
}

export default RideFormOne